(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[613],{

/***/ 57656:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(33815)


/***/ }),

/***/ 35727:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en-US/[business]/access/[category]/[article]",
      function () {
        return __webpack_require__(63837);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ business_share_icons; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(62991);
// EXTERNAL MODULE: ./node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(45630);
// EXTERNAL MODULE: ./components/business-share-icons/business-share-icons.module.scss
var business_share_icons_module = __webpack_require__(56908);
var business_share_icons_module_default = /*#__PURE__*/__webpack_require__.n(business_share_icons_module);
;// CONCATENATED MODULE: ./components/business-share-icons/social-and-share-icon/facebook-social.tsx


const FacebookSocial = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "47",
                height: "47",
                rx: "23.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.1495 17.8596C21.1495 17.7349 21.1668 17.4657 21.2014 17.0535C21.2386 16.6406 21.3945 16.2086 21.6741 15.7549C21.9511 15.303 22.4005 14.8969 23.0256 14.5376C23.648 14.1801 24.5476 14 25.7215 14H29.0288V17.6042H26.6072C26.3674 17.6042 26.144 17.6942 25.9423 17.8717C25.7423 18.0492 25.6393 18.218 25.6393 18.3747V20.617H29.0279C28.9924 21.056 28.9534 21.4828 28.9084 21.8949L28.7742 22.984C28.7206 23.352 28.666 23.6931 28.6123 24.0074H25.6151V34H21.1495V24.0065H18.9712V20.617H21.1495V17.8596Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "47",
                height: "47",
                rx: "23.5",
                stroke: "#EFF4FB"
            })
        ]
    });
};
/* harmony default export */ var facebook_social = (FacebookSocial);

;// CONCATENATED MODULE: ./components/business-share-icons/social-and-share-icon/linkedIn-social.tsx


const LinkedInSocial = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "47",
                height: "47",
                rx: "23.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.6705 15.0739C15.1177 14.653 15.7014 14.4424 16.4218 14.4424C17.1423 14.4424 17.7197 14.6529 18.1536 15.0739C18.5875 15.4949 18.809 16.0265 18.8177 16.6689C18.8263 17.3026 18.6071 17.8321 18.1602 18.2573C17.7132 18.6828 17.125 18.8954 16.3957 18.8954H16.3697C15.6579 18.8954 15.0849 18.6826 14.651 18.2573C14.217 17.8321 14 17.3024 14 16.6689C14 16.0264 14.2234 15.4949 14.6705 15.0739ZM32.6458 21.832C31.7432 20.8467 30.5494 20.354 29.0651 20.354C28.5183 20.354 28.0212 20.4213 27.574 20.5559C27.127 20.6904 26.7495 20.8792 26.4413 21.1223C26.1332 21.3653 25.8878 21.591 25.7057 21.7992C25.5325 21.997 25.3631 22.2274 25.1978 22.4881V20.6533H20.9138L20.9269 21.2783C20.9357 21.6951 20.9401 22.9798 20.9401 25.1324C20.9401 27.2853 20.9314 30.0933 20.914 33.5569H25.1978V26.3563C25.1978 25.9137 25.2453 25.5622 25.341 25.3015C25.5234 24.8586 25.7987 24.4878 26.1679 24.1884C26.5369 23.8887 26.9947 23.739 27.5417 23.739C28.288 23.739 28.8373 23.9972 29.1889 24.5137C29.5404 25.0301 29.7162 25.7441 29.7162 26.6556V33.5565H34V26.1612C33.9997 24.2599 33.5486 22.8169 32.6458 21.832ZM18.5441 20.6533H14.2473V33.5568H18.5441V20.6533Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "47",
                height: "47",
                rx: "23.5",
                stroke: "#EFF4FB"
            })
        ]
    });
};
/* harmony default export */ var linkedIn_social = (LinkedInSocial);

;// CONCATENATED MODULE: ./components/business-share-icons/social-and-share-icon/share.tsx


const MailShare = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "47",
                height: "47",
                rx: "23.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22 25C22.4295 25.5741 22.9774 26.0491 23.6066 26.3929C24.2357 26.7367 24.9315 26.9411 25.6467 26.9923C26.3618 27.0435 27.0796 26.9403 27.7513 26.6897C28.4231 26.4392 29.0331 26.047 29.54 25.54L32.54 22.54C33.4508 21.597 33.9548 20.3339 33.9434 19.023C33.932 17.712 33.4061 16.4579 32.4791 15.5309C31.5521 14.6038 30.298 14.078 28.987 14.0666C27.676 14.0552 26.413 14.5592 25.47 15.47L23.75 17.18",
                stroke: "black",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26 23.0002C25.5705 22.4261 25.0226 21.951 24.3934 21.6073C23.7642 21.2635 23.0684 21.0591 22.3533 21.0079C21.6382 20.9567 20.9204 21.0599 20.2486 21.3104C19.5769 21.561 18.9668 21.9532 18.46 22.4602L15.46 25.4602C14.5492 26.4032 14.0452 27.6662 14.0566 28.9772C14.068 30.2882 14.5938 31.5423 15.5209 32.4693C16.4479 33.3964 17.702 33.9222 19.0129 33.9336C20.3239 33.945 21.5869 33.441 22.53 32.5302L24.24 30.8202",
                stroke: "black",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "47",
                height: "47",
                rx: "23.5",
                stroke: "#EFF4FB"
            })
        ]
    });
};
/* harmony default export */ var share = (MailShare);

;// CONCATENATED MODULE: ./components/business-share-icons/social-and-share-icon/twitter-social.tsx


const TwitterSocial = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "47",
                height: "47",
                rx: "23.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M36 16.5585C35.1075 16.95 34.1565 17.2095 33.165 17.3355C34.185 16.7265 34.9635 15.7695 35.3295 14.616C34.3785 15.183 33.3285 15.5835 32.2095 15.807C31.3065 14.8455 30.0195 14.25 28.6155 14.25C25.8915 14.25 23.6985 16.461 23.6985 19.1715C23.6985 19.5615 23.7315 19.9365 23.8125 20.2935C19.722 20.094 16.1025 18.1335 13.671 15.147C13.2465 15.8835 12.9975 16.7265 12.9975 17.634C12.9975 19.338 13.875 20.8485 15.183 21.723C14.3925 21.708 13.617 21.4785 12.96 21.117C12.96 21.132 12.96 21.1515 12.96 21.171C12.96 23.562 14.6655 25.548 16.902 26.0055C16.5015 26.115 16.065 26.1675 15.612 26.1675C15.297 26.1675 14.979 26.1495 14.6805 26.0835C15.318 28.032 17.127 29.4645 19.278 29.511C17.604 30.8205 15.4785 31.6095 13.1775 31.6095C12.774 31.6095 12.387 31.5915 12 31.542C14.1795 32.9475 16.7625 33.75 19.548 33.75C28.602 33.75 33.552 26.25 33.552 19.749C33.552 19.5315 33.5445 19.3215 33.534 19.113C34.5105 18.42 35.331 17.5545 36 16.5585Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "47",
                height: "47",
                rx: "23.5",
                stroke: "#EFF4FB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white",
                        transform: "translate(12 12)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var twitter_social = (TwitterSocial);

;// CONCATENATED MODULE: ./components/business-share-icons/business-share-icons.tsx








if (true) {
    window.clipboardData = window.clipboardData || {};
}
const copyToClipboard = (text)=>{
    if ( true && (window === null || window === void 0 ? void 0 : window.clipboardData) && (window === null || window === void 0 ? void 0 : window.clipboardData.setData)) {
        return window === null || window === void 0 ? void 0 : window.clipboardData.setData("Text", text);
    } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed";
        document.body.appendChild(textarea);
        textarea.select();
        try {
            return document.execCommand("copy");
        } catch (ex) {
            console.warn("Copy to clipboard failed.", ex);
        } finally{
            document.body.removeChild(textarea);
        }
    }
    return false;
};
const handlePopupCenter = (param)=>{
    let { url , title , popupWidth , popupHeight  } = param;
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
    const systemZoom = width / window.screen.availWidth;
    const left = (width - popupWidth) / 2 / systemZoom + dualScreenLeft;
    const top = (height - popupHeight) / 2 / systemZoom + dualScreenTop;
    const newWindow = window.open(url, title, "\n      scrollbars=yes,\n      width=".concat(popupWidth / systemZoom, ", \n      height=").concat(popupHeight / systemZoom, ", \n      top=").concat(top, ", \n      left=").concat(left, "\n      "));
    if (window === null || window === void 0 ? void 0 : window.focus) newWindow === null || newWindow === void 0 ? void 0 : newWindow.focus();
};
const getUrlShare = (type, urlShare)=>{
    switch(type){
        case "facebook":
            return "https://www.facebook.com/sharer.php?u=".concat(urlShare);
        case "linkedIn":
            return "https://www.linkedin.com/sharing/share-offsite/?url=".concat(urlShare);
        case "twitter":
            return "https://twitter.com/intent/tweet?url=".concat(urlShare);
        case "mail":
            return "mailto:?body=".concat(urlShare);
        default:
            return urlShare;
    }
};
const getTooltipMessage = (type)=>{
    switch(type){
        case "facebook":
            return "Share on Facebook";
        case "linkedIn":
            return "Share on LinkedIn";
        case "twitter":
            return "Share on Twitter";
        case "mail":
            return "Click to copy";
        default:
            return "Click to copy";
    }
};
const socialAndShares = [
    {
        type: "facebook",
        urlShare: "",
        compShare: /*#__PURE__*/ (0,jsx_runtime.jsx)(facebook_social, {})
    },
    {
        type: "linkedIn",
        urlShare: "",
        compShare: /*#__PURE__*/ (0,jsx_runtime.jsx)(linkedIn_social, {})
    },
    {
        type: "twitter",
        urlShare: "",
        compShare: /*#__PURE__*/ (0,jsx_runtime.jsx)(twitter_social, {})
    },
    {
        type: "copy",
        urlShare: "",
        compShare: /*#__PURE__*/ (0,jsx_runtime.jsx)(share, {})
    }
];
const SocialAndShare = (props)=>{
    const [isCopied, setIsCopied] = react.useState(false);
    const { shareUrl =""  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_share_icons_module_default()).businessSocialAndShareContainer,
        children: (socialAndShares || []).map((item)=>{
            const linkShare = getUrlShare(item.type, item.urlShare || shareUrl);
            if (item.type === "copy") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.CopyToClipboard, {
                    text: linkShare,
                    onCopy: ()=>{
                        setIsCopied(true);
                        setTimeout(()=>{
                            setIsCopied(false);
                        }, 3000);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_share_icons_module_default()).businessSocialAndShareLink,
                        children: [
                            item.compShare,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (business_share_icons_module_default()).businessSocialAndShareTooltip,
                                children: isCopied ? "Copied" : getTooltipMessage(item.type)
                            })
                        ]
                    }, item.type)
                }, item.type);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_share_icons_module_default()).businessSocialAndShareLink,
                onClick: ()=>{
                    item.type === "copy" ? copyToClipboard(linkShare) : handlePopupCenter({
                        url: linkShare,
                        title: getTooltipMessage(item.type),
                        popupWidth: 400,
                        popupHeight: 300
                    });
                },
                children: [
                    item.compShare,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (business_share_icons_module_default()).businessSocialAndShareTooltip,
                        children: getTooltipMessage(item.type)
                    })
                ]
            }, item.type);
        })
    });
};
/* harmony default export */ var business_share_icons = (SocialAndShare);


/***/ }),

/***/ 63837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ ArticlePage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/@builder.io/react/dist/builder-react.es5.js
var builder_react_es5 = __webpack_require__(75102);
// EXTERNAL MODULE: ./node_modules/next/error.js
var error = __webpack_require__(57656);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(42132);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(75407);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(62991);
// EXTERNAL MODULE: ./builder/index.ts + 318 modules
var builder = __webpack_require__(21776);
// EXTERNAL MODULE: ./components/business-button/business-button.tsx
var business_button = __webpack_require__(52955);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-back-to-latest-article/b2b-back-to-latest-article.module.scss
var b2b_back_to_latest_article_module = __webpack_require__(55154);
var b2b_back_to_latest_article_module_default = /*#__PURE__*/__webpack_require__.n(b2b_back_to_latest_article_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-back-to-latest-article/b2b-back-to-latest-article.tsx




const B2BBackToLatestArticle = (props)=>{
    const { latestArticleUrl  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (b2b_back_to_latest_article_module_default()).backToLatestArticle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
            link: latestArticleUrl,
            color: "black",
            buttonText: "Back to access",
            autoMargin: false
        })
    });
};
/* harmony default export */ var b2b_back_to_latest_article = (B2BBackToLatestArticle);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(56779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-category/b2b-category.tsx
var b2b_category = __webpack_require__(94430);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-categories-block/b2b-categories-block.module.scss
var b2b_categories_block_module = __webpack_require__(7984);
var b2b_categories_block_module_default = /*#__PURE__*/__webpack_require__.n(b2b_categories_block_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-categories-block/b2b-categories-block.tsx





const B2BCategoriesBlock = (props)=>{
    const { categories  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (b2b_categories_block_module_default()).articleCategoriesContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: classnames_default()((b2b_categories_block_module_default()).categoriesHeading),
                children: "Categories"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_category/* B2BCategory */.M, {
                categories: categories
            })
        ]
    });
};
/* harmony default export */ var b2b_categories_block = (B2BCategoriesBlock);

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-hero/b2b-hero.tsx
var b2b_hero = __webpack_require__(16779);
// EXTERNAL MODULE: ./components/business-share-icons/business-share-icons.tsx + 4 modules
var business_share_icons = __webpack_require__(78916);
// EXTERNAL MODULE: ./components/layouts/b2b-layout.tsx + 13 modules
var b2b_layout = __webpack_require__(78506);
// EXTERNAL MODULE: ./components/meta-block/MetaBlock.tsx
var MetaBlock = __webpack_require__(22135);
// EXTERNAL MODULE: ./helpers/BuilderHelper.ts
var BuilderHelper = __webpack_require__(31198);
// EXTERNAL MODULE: ./helpers/LangHelper.ts
var LangHelper = __webpack_require__(77868);
// EXTERNAL MODULE: ./models/ArticleModel.ts + 1 modules
var ArticleModel = __webpack_require__(84618);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.mjs
var swiper = __webpack_require__(78592);
// EXTERNAL MODULE: ./node_modules/swiper/modules/index.mjs + 27 modules
var modules = __webpack_require__(94135);
// EXTERNAL MODULE: ./node_modules/swiper/swiper-react.mjs + 2 modules
var swiper_react = __webpack_require__(48929);
// EXTERNAL MODULE: ./components/icons/index.tsx + 91 modules
var icons = __webpack_require__(66714);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-article-card/b2b-article-card.tsx
var b2b_article_card = __webpack_require__(1395);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-related-articles/b2b-related-articles.module.scss
var b2b_related_articles_module = __webpack_require__(63599);
var b2b_related_articles_module_default = /*#__PURE__*/__webpack_require__.n(b2b_related_articles_module);
// EXTERNAL MODULE: ./components/business-button/business-button.constants.ts
var business_button_constants = __webpack_require__(79892);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-related-articles/b2b-related-articles.tsx










swiper/* default.use */.Z.use([
    modules/* Navigation */.W_
]);
const B2BRelatedArticles = (props)=>{
    const { title , description , viewAllSeriesText , viewAllSeriesUrl , articles  } = props.relatedArticles;
    if (!articles || articles.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (b2b_related_articles_module_default()).relatedArticlesContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_related_articles_module_default()).relatedArticlesHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (b2b_related_articles_module_default()).relatedArticlesHeaderInfo,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (b2b_related_articles_module_default()).relatedArticlesHeaderTitle,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (b2b_related_articles_module_default()).relatedArticlesHeaderDescription,
                            children: description
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_related_articles_module_default()).relatedArticleSlider,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    slidesPerView: "auto",
                    spaceBetween: 8,
                    centeredSlides: true,
                    centeredSlidesBounds: true,
                    watchOverflow: true,
                    lazyPreloadPrevNext: 1,
                    updateOnWindowResize: true,
                    className: (b2b_related_articles_module_default()).relatedArticleSliderSeoSeriesSlider,
                    breakpoints: {
                        1440: {
                            spaceBetween: 24
                        }
                    },
                    children: (articles || []).map((article)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            className: (b2b_related_articles_module_default()).relatedArticleSlide,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_article_card/* default */.Z, {
                                type: b2b_article_card/* ArticleCardType.Small */._.Small,
                                article: article
                            })
                        }, article.articleUrl);
                    })
                }, title)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                className: (b2b_related_articles_module_default()).relatedArticlesViewAll,
                link: viewAllSeriesUrl,
                icon: icons/* IconType.ArrowRightSmall */.T.ArrowRightSmall,
                autoMargin: false,
                color: business_button_constants/* COLORS.BLACK */.DM.BLACK,
                target: "_self",
                buttonText: viewAllSeriesText
            })
        ]
    });
};
/* harmony default export */ var b2b_related_articles = (B2BRelatedArticles);

;// CONCATENATED MODULE: ./pages/en-US/[business]/access/[category]/[article].tsx

















(0,builder/* registerComponents */.QR)();
var __N_SSG = true;
function ArticlePage(ctx) {
    const { article , relatedArticles  } = ctx;
    const router = (0,next_router.useRouter)();
    const locale = LangHelper/* Locale.USA */.go.USA;
    const [stateArticle, setStateArticle] = (0,react.useState)(article);
    (0,react.useEffect)(()=>{
        let cancelled = false;
        if ((builder_react_es5/* Builder.isPreviewing */.Ib.isPreviewing || builder_react_es5/* Builder.isEditing */.Ib.isEditing) && router.query["builder.overrides.article"]) {
            ArticleModel/* default.findById */.Z.findById(router.query["builder.overrides.article"]).then((articleFromBuilder)=>{
                if (articleFromBuilder && !cancelled) {
                    const mappedArticle = ArticleModel/* default.fromBuilderContent */.Z.fromBuilderContent(articleFromBuilder);
                    setStateArticle(mappedArticle);
                }
            });
        } else if (article) {
            setStateArticle(article);
        }
        return ()=>{
            cancelled = true;
        };
    }, [
        article,
        router.query
    ]);
    if (router.isFallback) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
            children: "Loading..."
        });
    }
    const isLive = !builder_react_es5/* Builder.isEditing */.Ib.isEditing && !builder_react_es5/* Builder.isPreviewing */.Ib.isPreviewing;
    if (!stateArticle && isLive) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "robots",
                            content: "noindex"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "title"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(error["default"], {
                    statusCode: 404
                })
            ]
        });
    }
    if (!stateArticle) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
            children: "Loading..."
        });
    }
    const leadCategory = (0,BuilderHelper/* mapBuilderObjectToCategory */.yP)(stateArticle === null || stateArticle === void 0 ? void 0 : stateArticle.categories[0]);
    const relatedArticlesData = {
        title: leadCategory === null || leadCategory === void 0 ? void 0 : leadCategory.name,
        description: leadCategory === null || leadCategory === void 0 ? void 0 : leadCategory.description,
        viewAllSeriesText: "View All Articles",
        viewAllSeriesUrl: (0,LangHelper/* localifyLink */.Bj)("/".concat(locale).concat(leadCategory.categoryUrl), locale),
        articles: relatedArticles
    };
    let targetUrl = "/".concat(locale).concat(stateArticle.articleUrl);
    if (true) {
        targetUrl = "".concat((window === null || window === void 0 ? void 0 : window.origin) || "", "/").concat(locale).concat(stateArticle.articleUrl);
    }
    var _seoTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaBlock/* default */.Z, {
                title: (_seoTitle = stateArticle.seoTitle) !== null && _seoTitle !== void 0 ? _seoTitle : stateArticle.title,
                description: stateArticle.seoDescription,
                leadImage: stateArticle.leadImage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(b2b_layout/* default */.Z, {
                page: stateArticle,
                model: "article",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_hero/* default */.Z, {
                        title: stateArticle.title,
                        titleMaxWidth: 540,
                        backgroundImage: {
                            desktop: stateArticle.leadImage,
                            mobile: stateArticle.imageMobile
                        },
                        articleCategories: stateArticle.categories,
                        position: stateArticle.position
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_react_es5/* BuilderComponent */.VD, {
                        model: "article",
                        content: stateArticle.builderModel
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_categories_block, {
                        categories: stateArticle.categories
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(business_share_icons/* default */.Z, {
                        shareUrl: targetUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_back_to_latest_article, {
                        latestArticleUrl: (0,LangHelper/* localifyLink */.Bj)("/".concat(locale, "/business/access"), locale)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_related_articles, {
                        relatedArticles: relatedArticlesData
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 55154:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"backToLatestArticle":"b2b-back-to-latest-article_backToLatestArticle__ZW41R"};

/***/ }),

/***/ 7984:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articleCategoriesContainer":"b2b-categories-block_articleCategoriesContainer__kVxMi","categoriesHeading":"b2b-categories-block_categoriesHeading__t3Hlj"};

/***/ }),

/***/ 63599:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"relatedArticlesContainer":"b2b-related-articles_relatedArticlesContainer__5t5G9","relatedArticlesHeader":"b2b-related-articles_relatedArticlesHeader__06O7G","relatedArticlesViewAll":"b2b-related-articles_relatedArticlesViewAll__zKeL9","relatedArticlesHeaderTitle":"b2b-related-articles_relatedArticlesHeaderTitle__sRN1E","relatedArticlesHeaderDescription":"b2b-related-articles_relatedArticlesHeaderDescription__iJW7A","relatedArticleSlider":"b2b-related-articles_relatedArticleSlider__WMz0O","relatedArticleSlide":"b2b-related-articles_relatedArticleSlide__slLHa","video-spin":"b2b-related-articles_video-spin__whRk_"};

/***/ }),

/***/ 56908:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessSocialAndShareContainer":"business-share-icons_businessSocialAndShareContainer__R7gfs","businessSocialAndShareLink":"business-share-icons_businessSocialAndShareLink__kFJ96","businessSocialAndShareTooltip":"business-share-icons_businessSocialAndShareTooltip__M7ME6"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [565,886,564,506,774,888,179], function() { return __webpack_exec__(35727); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);